import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { BannerConfig } from '../shared/components/banner/banner.component';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-action-required-status',
  templateUrl: './action-required-status.component.html',
  styleUrls: ['./action-required-status.component.scss']
})
export class ActionRequiredStatusComponent implements OnInit {

  showBanner = false;
  componentDestroy: Subject<any> = new Subject();
  @Input() bannerMessage: string;
  @Input() bannerButton: string;
  @Input() onReAuthenticate: () => void;
  @Input() onSettings: ()=> void;
  bannerConfig: BannerConfig = {
    theme: 'action-required',
    title: '',
    description: '',
    buttonText: '',
    buttonUrl: ''
  };
  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.bannerMessage && this.bannerMessage) {
      this.bannerConfig.title = this.bannerMessage;
      this.bannerConfig.buttonText = this.bannerButton;
      this.showBanner = true;  // Show the banner only after the bannerMessage is received
    }
  }
  ngOnInit(): void {
    console.log('inside banner for details page')
  }

  customButtonClickHandler(event: Event): void {
    console.log("Custom handler executed.");
    if (this.bannerConfig.buttonText === 'Re-Authenticate') {
      if (this.onReAuthenticate) {
        this.onReAuthenticate();
      }
    }
    if (this.bannerConfig.buttonText === 'Settings') {
      if (this.onSettings)
        this.onSettings();
    }
    if (this.bannerConfig.buttonText === 'Contact Support') {
     // this.onReAuthenticate();
      // window.HubSpotConversations.widget.open();
      if (window && (window as any).HubSpotConversations) {
        (window as any).HubSpotConversations.widget.open();
      } else {
        console.log("HubSpotConversations is not available.");
      }
    }
    else if (this.bannerConfig.buttonUrl) {
      window.open(this.bannerConfig.buttonUrl, '_blank');
    }
  }
}
